import { render, staticRenderFns } from "./InvoiceItemsTable.vue?vue&type=template&id=366017b0&scoped=true&"
import script from "./InvoiceItemsTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemsTable.vue?vue&type=style&index=0&id=366017b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366017b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCombobox,VExpandTransition,VIcon,VRow,VSelect,VSimpleTable,VTextField,VTooltip})
